import React, { useState } from 'react';
import FilterSection from '../../components/CategoryPages/Wellbeing/Sections/FilterSection';
import Header from '../../components/CategoryPages/Wellbeing/Sections/Header';
import MainSection from '../../components/CategoryPages/Wellbeing/Sections/MainSection';
import withPageWrapper from '../../components/Shared/HOCs/withPageWrapper';
import { returnHasTags } from '../../utils/helpers';
import useGetSongs from '../../hooks/Song/useGetSongs';
import useGetResources from '../../hooks/Resource/useGetResources';
import { updateQuery } from '../../utils/objects';
import { buildResourceParams } from '../../utils/resource';

const Wellbeing = () => {
  const [displaySongs, setDisplaySongs] = useState(true);
  const [displayResources, setDisplayResources] = useState(true);
  const [displayPlaylists, setDisplayPlaylists] = useState(true);
  const [filterParams, setFilterParams] = useState({});

  const {
    data: songs,
    fetchMore: fetchMoreSongs,
    loading: loadingSongs,
  } = useGetSongs(
    6,
    returnHasTags('hasSongTags', 'OOTA Singing School', 'Wellbeing', true),
    true
  );

  const {
    data: resources,
    fetchMore: fetchMoreResources,
    loading: loadingResources,
  } = useGetResources(
    2,
    returnHasTags('hasTags', 'OOTA Singing School', 'Wellbeing')
  );

  const handleFilter = (params) => {
    const resourceParams = buildResourceParams(params);

    fetchMoreSongs({
      variables: { ...params },
      ...updateQuery,
    });
    fetchMoreResources({
      variables: { ...resourceParams },
      ...updateQuery,
    });
    setDisplaySongs(true);
    setDisplayResources(true);
    setDisplayPlaylists(true);
    setFilterParams(params);
  };

  const loading = loadingResources || loadingSongs;

  return (
    <>
      <Header />
      <FilterSection handleFilter={handleFilter} loading={loading} />
      <MainSection
        songs={songs?.songs?.data}
        resources={resources?.resources?.data}
        displayResources={displayResources}
        displaySongs={displaySongs}
        displayPlaylists={displayPlaylists}
        filterParams={filterParams}
      />
    </>
  );
};

export default withPageWrapper({})(Wellbeing);
